//---- Automatically generated, don't update this part ----
/**
 * Describes a DMP document metadata, retrieved during the TD3.1 transaction.
 */
interface Author {
  institution: {
    classCode: string;
    id: string;
    name: string;
  };
  handle: number;
  hpAuthenticationMode: number;
  hpInternalIdType: number;
  hpGiven: string;
  hpInstitution: string;
  hpInternalId: string;
  hpName: string;
  hpProfession: string;
  hpProfessionDescription: string;
  hpProfessionOid: string;
  hpSpeciality: string;
  hpSpecialityDescription: string;
}

interface DmpConnectInstitution {
  s_classCode: string;
  s_id: string;
  s_name: string;
}

interface DmpConnectAuthor {
  Institution: DmpConnectInstitution;
  i_handle: number;
  i_hpAuthenticationMode: number;
  i_hpInternalIdType: number;
  s_hpGiven: string;
  s_hpInstitution: string;
  s_hpInternalId: string;
  s_hpName: string;
  s_hpProfession: string;
  s_hpProfessionDescription: string;
  s_hpProfessionOid: string;
  s_hpSpeciality: string;
  s_hpSpecialityDescription: string;
}

export interface DmpConnectDmpDocumentMetadata {
  Authors: DmpConnectAuthor[];
  EventCodes: any[];
  i_document_Format: number;
  i_document_Status: number;
  i_document_Visibility: number;
  i_handle: number;
  i_size: number;
  s_classCode: string;
  s_creationDate: string;
  s_description: string;
  s_documentFormatCode: string;
  s_documentFormatDescription: string;
  s_hashSha1: string;
  s_healthCareFacilityTypeCode: string;
  s_nextUUId: string;
  s_practiceSettingCode: string;
  s_previousUUId: string;
  s_serviceStartDate: string;
  s_serviceStopDate: string;
  s_submissionDate: string;
  s_submissionSetId: string;
  s_title: string;
  s_typeCode: string;
  s_uniqueId: string;
  s_uuid: string;
}

interface Params {
  authors?: Author[];
  eventCodes?: any[];
  documentFormat?: number;
  documentStatus?: number;
  documentVisibility?: number;
  handle?: number;
  size?: number;
  classCode: string;
  creationDate?: string;
  description: string;
  documentFormatCode?: string;
  documentFormatDescription?: string;
  hashSha1?: string;
  healthCareFacilityTypeCode?: string;
  nextUUId?: string;
  practiceSettingCode?: string;
  previousUUId?: string;
  serviceStartDate?: string;
  serviceStopDate?: string;
  submissionDate?: string;
  submissionSetId?: string;
  title: string;
  type: string;
  uniqueId: string;
  uuid: string;
  confidentialities: string[];
  creationTime?: Date;
  format?: string;
  formatDescription?: string;
  mimeType?: string;
  status: string[];
}

export default class DmpDocumentMetadata {
  constructor(params: Params) {
    this.authors = params.authors || [];
    this.eventCodes = params.eventCodes || [];
    this.documentFormat = params.documentFormat;
    this.documentStatus = params.documentStatus;
    this.documentVisibility = params.documentVisibility;
    this.handle = params.handle;
    this.size = params.size;
    this.classCode = params.classCode;
    this.creationDate = params.creationDate;
    this.description = params.description;
    this.documentFormatCode = params.documentFormatCode;
    this.documentFormatDescription = params.documentFormatDescription;
    this.hashSha1 = params.hashSha1;
    this.healthCareFacilityTypeCode = params.healthCareFacilityTypeCode;
    this.nextUUId = params.nextUUId;
    this.practiceSettingCode = params.practiceSettingCode;
    this.previousUUId = params.previousUUId;
    this.serviceStartDate = params.serviceStartDate;
    this.serviceStopDate = params.serviceStopDate;
    this.submissionDate = params.submissionDate;
    this.submissionSetId = params.submissionSetId;
    this.title = params.title;
    this.type = params.type;
    this.uniqueId = params.uniqueId;
    this.uuid = params.uuid;
    this.confidentialities = params.confidentialities;
    this.creationTime = params.creationTime;
    this.format = params.format;
    this.formatDescription = params.formatDescription;
    this.mimeType = params.mimeType;
    this.status = params.status;
  }

  toJson() {
    return {
      authors: this.authors,
      eventCodes: this.eventCodes,
      documentFormat: this.documentFormat,
      documentStatus: this.documentStatus,
      documentVisibility: this.documentVisibility,
      handle: this.handle,
      size: this.size,
      classCode: this.classCode,
      creationDate: this.creationDate,
      description: this.description,
      documentFormatCode: this.documentFormatCode,
      documentFormatDescription: this.documentFormatDescription,
      hashSha1: this.hashSha1,
      healthCareFacilityTypeCode: this.healthCareFacilityTypeCode,
      nextUUId: this.nextUUId,
      practiceSettingCode: this.practiceSettingCode,
      previousUUId: this.previousUUId,
      serviceStartDate: this.serviceStartDate,
      serviceStopDate: this.serviceStopDate,
      submissionDate: this.submissionDate,
      submissionSetId: this.submissionSetId,
      title: this.title,
      type: this.type,
      uniqueId: this.uniqueId,
      uuid: this.uuid,
      confidentialities: this.confidentialities,
      creationTime: this.creationTime,
      format: this.format,
      formatDescription: this.formatDescription,
      mimeType: this.mimeType,
      status: this.status
    };
  }

  authors: Author[] = [];

  eventCodes: any[] = [];

  documentFormat?: number;

  documentStatus?: number;

  documentVisibility?: number;

  handle?: number;

  size?: number;

  classCode: string;

  creationDate?: string;

  confidentialities: string[];

  creationTime?: Date;

  description: string;

  documentFormatCode?: string;

  documentFormatDescription?: string;

  format?: string;

  formatDescription?: string;

  hashSha1?: string;

  healthCareFacilityTypeCode?: string;

  mimeType?: string;

  nextUUId?: string;

  practiceSettingCode?: string;

  previousUUId?: string;

  serviceStartDate?: string;

  serviceStopDate?: string;

  status: string[];

  submissionDate?: string;

  submissionSetId?: string;

  title: string;

  type: string;

  uniqueId: string;

  uuid: string;

  //---- End of generated code ----
}
